export enum SlownikEnum {
  TERYT_WOJ = 'TERYT_WOJ',
}
